import $axios from '@/axios-instance.js'

export const staffTimeLogService = {
  getAll,
  getById,
  getByUserIdAndYearMonth,
  getReadOnlyListByUserId,
  getHistoryByUserId,
  create,
  update,
  delete: _delete
}

function getAll (filter) {
  return $axios.get(`${process.env.ROOT_API}/stafftimelogs`, { params: filter }).then(response => {
    return response.data
  })
}

function getById (id) {
  return $axios.get(`${process.env.ROOT_API}/stafftimelogs/${id}`).then(response => {
    return response.data
  })
}

function getByUserIdAndYearMonth (userId, year, month) {
  return $axios.get(`${process.env.ROOT_API}/staffTimeLogs/getByUserId/${userId}/${year}/${month}`).then(response => {
    return response.data
  })
}

function getReadOnlyListByUserId (userId) {
  return $axios.get(`${process.env.ROOT_API}/staffTimeLogs/getReadOnlyListByUserId/${userId}`).then(response => {
    return response.data
  })
}

function getHistoryByUserId (userId) {
  return $axios.get(`${process.env.ROOT_API}/stafftimelogsHistoryByUserId/${userId}`).then(response => {
    return response.data
  })
}

function create (stafftimelog) {
  return $axios.post(`${process.env.ROOT_API}/stafftimelogs`, stafftimelog).then(response => {
    return response.data
  })
}

function update (stafftimelog) {
  return $axios.put(`${process.env.ROOT_API}/stafftimelogs/${stafftimelog.staffTimeLogId}`, stafftimelog).then(response => {
    return response.data
  })
}

function _delete (id) {
  return $axios.delete(`${process.env.ROOT_API}/stafftimelogs/${id}`).then(response => {
    return response.data
  })
}



// WEBPACK FOOTER //
// ./src/services/stafftimelog.service.js